import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SupplyRegisterService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  SupplyRegisterCreateDto,
  SupplyRegisterDto,
  SupplyRegisterExcelDownloadDto,
  SupplyRegisterUpdateDto,
} from '../proxy/planning/dtos/supply-register';
import { SUPPLYREGISTER_CONFIG, SUPPLYREGISTER_FIELDS } from './supply-register.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-supply-register',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, SupplyRegisterService, ConfirmationService],
  templateUrl: './supply-register.html',
  styleUrl: './supply-register.scss',
})
export class SupplyRegister extends BaseHierarchicalCrudComponent<
  SupplyRegisterDto,
  SupplyRegisterCreateDto,
  SupplyRegisterUpdateDto,
  SupplyRegisterExcelDownloadDto
> {
  service = inject(SupplyRegisterService);
  config = SUPPLYREGISTER_CONFIG;
  fields = SUPPLYREGISTER_FIELDS;

  protected prepareUpdateDto(data: any, selected: SupplyRegisterDto): SupplyRegisterUpdateDto {
    return {
      ...data,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'SupplyRegister';
  }
}
